// extracted by mini-css-extract-plugin
export default {"selectTaxi":"DriverTaxi_selectTaxi__LQ24+","active":"DriverTaxi_active__MV2Ca","taxiTypeBody":"DriverTaxi_taxiTypeBody__XT-qE"};